import { render, staticRenderFns } from "./ArticleInfoTtsPlayer.vue?vue&type=template&id=19256f22&scoped=true"
import script from "./ArticleInfoTtsPlayer.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoTtsPlayer.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoTtsPlayer.vue?vue&type=style&index=0&id=19256f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19256f22",
  null
  
)

export default component.exports